import $axios from './api';

export const create = async ({ courseId, module }) => {
	const { data } = await $axios.post(`/v1/author/course/${courseId}/module/create`, module);
	return data;
};

export const remove = async ({ courseId, moduleId }) => {
	const { data } = await $axios.delete(`/v1/author/course/${courseId}/module/${moduleId}`);
	return data;
};

export const edit = async ({ courseId, module }) => {
	const { data } = await $axios.post(`/v1/author/course/${courseId}/module/${module.id}`, module);
	return data;
};

export const removeAttachment = async ({ courseId, moduleId, attachmentId }) => {
	const { data } = await $axios.delete(`/v1/author/course/${courseId}/module/${moduleId}/attach/${attachmentId}`);
	return data;
};


export const marathonCreate = async ({ marathonId, module }) => {
	const { data } = await $axios.post(`/v1/author/marathon/${marathonId}/module/create`, module);
	return data;
};

export const marathonRemove = async ({ marathonId, moduleId }) => {
	const { data } = await $axios.delete(`/v1/author/marathon/${marathonId}/module/${moduleId}`);
	return data;
};

export const marathonEdit = async ({ marathonId, module }) => {
	const { data } = await $axios.post(`/v1/author/marathon/${marathonId}/module/${module.id}`, module);
	return data;
};

export const marathonRemoveAttachment = async ({ marathonId, moduleId, attachmentId }) => {
	const { data } = await $axios.delete(`/v1/author/marathon/${marathonId}/module/${moduleId}/attach/${attachmentId}`);
	return data;
};

export const getCourseAttachmentLink = async ({ courseId, attachmentId }) => {
	const response = await $axios.get(`/v1/author/course/${courseId}/attach/${attachmentId}/link`, {
		maxRedirects: 0,
		validateStatus: (status) => status === 302 || status === 200
	});
	return response.headers.location || response.request?.responseURL;
};

export const getMarathonAttachmentLink = async ({ marathonId, attachmentId }) => {
	const response = await $axios.get(`/v1/author/marathon/${marathonId}/attach/${attachmentId}/link`, {
		maxRedirects: 0,
		validateStatus: (status) => status === 302 || status === 200
	});
	return response.headers.location || response.request?.responseURL;
};

